import { SystemServiceType } from '@app/api/nts/model/systemServiceType';
import { Validators } from '@angular/forms';
import { KeyValue } from '@shared/interfaces/key-value/key-value';

export const systemServiceTypeOptions: KeyValue[] = Object.values(SystemServiceType).filter(type => type !== SystemServiceType.NotSpecified).map(type => ({
  key: type,
  value: `systemServices.types.${type}`,
}));

export const systemServicesCapacityValidators = [
  Validators.min(0),
  Validators.max(999999.9),
  Validators.pattern(/^\d+(?:\.\d)?$/),
];
